export default "var ORNA_BACKEND_VERSION = 242;\r\n"